<template>
  <div>
    <div class="common" v-if="!isRule">
      <!-- 搜索 -->
      <div class="top clearfix">
        <div class="fl">
          搜索：
          <el-input
            style="width: 150px"
            placeholder="请输入关键字"
            v-model="searchKey"
            size="small"
            @change="selectLsit(1)"
            clearable
          >
          </el-input>
          学年：
          <el-date-picker
            class="search-year"
            v-model="searchYear"
            value-format="yyyy"
            size="small"
            type="year"
            @change="selectLsit(1)"
          >
          </el-date-picker>
          学期：
          <el-select
            clearable
            v-model="searchTerm"
            size="small"
            @change="selectLsit(1)"
          >
            <template v-for="i of dic.schoolTerm">
              <el-option :label="i.dicName" :value="i.dicCode"></el-option>
            </template>
          </el-select>
        </div>
        <div class="fr">
          <el-button
            size="small"
            icon="iconfont icon-daochu"
            @click="importTeacher"
            v-if="isAdmin"
            >导出</el-button
          >
          <el-button size="small" icon="iconfont icon-add" @click="showAddPop"
            >新增</el-button
          >
          <icon-integral-rule
            :isRule="isRule"
            @openRule="isRule = true"
          ></icon-integral-rule>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.9)"
        v-loading="isTableLoading"
        row-key="id"
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ background: '#EFEFEF' }"
      >
        <el-table-column prop="schoolYear" label="学年" width="60">
        </el-table-column>
        <el-table-column prop="schoolTermDesc" label="学期" width="100">
        </el-table-column>
        <el-table-column prop="awardDate" label="获奖日期" width="130">
        </el-table-column>
        <el-table-column prop="studentName" label="获奖学生" width="80">
        </el-table-column>
        <el-table-column prop="teacherName" label="指导教师" width="80">
        </el-table-column>
        <el-table-column prop="awardTypeDesc" label="获奖类别" width="100">
        </el-table-column>
        <el-table-column prop="awardName" label="获奖项目"> </el-table-column>
        <el-table-column prop="awardType1Desc" label="获奖等级" width="130">
        </el-table-column>
        <el-table-column prop="remark" label="其他获奖等级说明">
        </el-table-column>
        <el-table-column prop="awardingUnit" label="颁奖单位" width="130">
        </el-table-column>
        <el-table-column label="附件" width="60">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="
                showImg(
                  scope.row.awardAttaches[0].url,
                  '指导学生获奖',
                  scope.row.awardAttaches
                )
              "
              >查看</el-button
            >
          </template>
        </el-table-column>

        <!-- <el-table-column
          prop="score"
          label="获得积分"
        >
        </el-table-column>-->
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              :disabled="isDisabled(scope)"
              type="text"
              class="text-edit"
              @click="showEdit(scope.$index, scope.row)"
              >编辑</el-button
            >|
            <el-button
              :disabled="isDisabled(scope)"
              type="text"
              class="text-del"
              @click="showDelPop(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :pageObj="pageObj"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
      </pagination>
      <!-- 删除的对话框 -->
      <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>

      <!-- 新增的对话框 -->
      <el-dialog
        class="add-pop"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        width="40%"
        top="5%"
      >
        <template v-slot:title>
          <div class="add-title">{{ form.id ? "编 辑" : "新 增" }}</div>
        </template>
        <!-- 对话框内容部分 => 匿名插槽 -->
        <el-form ref="form" :rules="rules" :model="form" label-width="130px">
          <el-form-item label="学年" prop="schoolYear">
            <el-date-picker
              class="width-form-input"
              v-model="form.schoolYear"
              value-format="yyyy"
              type="year"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="学期" prop="schoolTerm">
            <el-select v-model="form.schoolTerm" placeholder="请选择">
              <template v-for="i of dic.schoolTerm">
                <el-option
                  :key="i.id"
                  :label="i.dicName"
                  :value="i.dicCode"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="获奖日期" prop="awardDate">
            <el-date-picker
              class="width-form-input"
              v-model="form.awardDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-form-item>
          <!-- 教师姓名 -->

          <el-form-item label="获奖学生" prop="studentName">
            <el-input
              placeholder="请输入"
              v-model="form.studentName"
            ></el-input>
          </el-form-item>
          <el-form-item label="指导教师" prop="teacherId">
            <el-select
              v-model="form.teacherId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入教师姓名关键字"
              :remote-method="teacherKeyChange"
              :loading="teacherLoading"
            >
              <el-option
                v-for="item in teacherOptions"
                :key="item.id"
                :label="
                  item.teacherNum
                    ? item.userName + '(师训号:' + item.teacherNum + ')'
                    : item.userName
                "
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="获奖类别" prop="awardType">
            <el-select v-model="form.awardType" placeholder="请选择">
              <template v-for="i of awardTypeOptions">
                <el-option
                  :key="i.id"
                  :label="i.dicName"
                  :value="i.dicCode"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="获奖项目" prop="awardName">
            <el-input placeholder="请输入" v-model="form.awardName"></el-input>
          </el-form-item>
          <el-form-item label="获奖等级" prop="awardType1">
            <el-select
              v-model="form.awardType1"
              placeholder="请选择"
              @change="getScore"
            >
              <template v-for="i of ruleOptions">
                <el-option
                  :key="i.id"
                  :label="i.integralName"
                  :value="i.integralCode"
                ></el-option>
              </template>
            </el-select>
            <!-- <el-cascader @change="getIntegralNum" class="width-form-input" :props="defaultProps" v-model="form.ruleList"
                         :options="ruleOptions"></el-cascader> -->
          </el-form-item>
          <el-form-item label="其他获奖等级说明" prop="remark">
            <el-input placeholder="请输入" v-model="form.remark"></el-input>
          </el-form-item>
          <el-form-item label="颁奖单位" prop="awardingUnit">
            <el-input
              placeholder="请输入"
              v-model="form.awardingUnit"
            ></el-input>
          </el-form-item>

          <el-form-item label="上传附件" prop="awardAttaches">
            <upload
              :limit="10"
              v-if="addVisible"
              :allowType="1"
              :fileLimit="50"
              :fileList="form.awardAttaches"
              :fileUrl="form.awardAttach"
              @uploadFileUrl="uploadFileUrl"
            ></upload>
            <div style="font-size: 12px">
              *证书、公示文件、发表刊物封面、目录及文章首页等
            </div>
          </el-form-item>
        </el-form>
        <template v-slot:footer>
          <span class="dialog-footer">
            <el-button @click="submitStudent" type="primary">提 交</el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 图片预览弹框 -->
      <ViewImg :img-path-list="imgPathList" :is-show.sync="imgVisible" />
    </div>

    <div v-else>
      <integral-rule-view @closeRule="isRule = false"></integral-rule-view>
    </div>
  </div>
</template>

<script>
import PopupDel from "@/components/PopupDel.vue";
import IconIntegralRule from "@/components/IconIntegralRule.vue";
import IntegralRuleView from "@/components/IntegralRuleView.vue";
import Pagination from "@/components/Pagination.vue";
import Upload from "@/components/Upload.vue";
import { teacherKeyChange, exportExecl } from "@/utils/index";
import { mapState } from "vuex";
import { mixin } from "@/mixin/mixin";
import ViewImg from "@/components/ViewImg.vue";

export default {
  mixins: [mixin],
  components: {
    PopupDel,
    IconIntegralRule,
    IntegralRuleView,
    Upload,
    Pagination,
    ViewImg,
  },
  computed: {
    ...mapState([
      "isAdmin",
      "userInfo",
      "dic",
      "teacherOptions",
      "teacherLoading",
      "ruleOptions",
      "ruleOptionsList",
    ]),
    count() {
      return this.$store.getters.curMonth;
    },
  },
  data() {
    return {
      imgVisible: false,
      imgUrl: "",
      searchKey: "",
      awardTypeOptions: [],
      form: {
        awardingUnit: "",
        remark: "",
        awardType: "",
        awardName: "",
        studentName: "",
        awardDate: "",
        awardAttach: "", //附件
        awardAttaches: [],
      },
      rules: {
        awardDate: [
          {
            required: true,
            message: "请选择获奖日期",
            trigger: ["change", "blur"],
          },
        ],
        awardType: [
          {
            required: true,
            message: "请选择获奖类别",
            trigger: ["change", "blur"],
          },
        ],
        awardName: [
          {
            required: true,
            message: "请输入获奖名称",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: ["change", "blur"],
          },
        ],
        awardingUnit: [
          {
            required: true,
            message: "请输入颁奖单位",
            trigger: ["change", "blur"],
          },
        ],
        studentName: [
          {
            required: true,
            message: "请输入获奖学生",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: ["change", "blur"],
          },
        ],
        awardType1: [
          {
            required: true,
            message: "请选择获奖等级",
            trigger: ["change", "blur"],
          },
        ],
        awardAttaches: [
          {
            required: true,
            message: "请选择附件",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  created() {
    this.getDicAwards();
  },
  methods: {
    // 获奖类型字典
    getDicAwards() {
      const paramsDic = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        dicType: "awardClassify",
        schoolCode: this.userInfo.schoolCode,
      };
      this.$axios
        .get("/dic/listDictionaryByDicType", { params: paramsDic })
        .then((res) => {
          if (res.data.records && res.data.records.length > 0) {
            this.awardTypeOptions = res.data.records;
          }
        });
    },
    //首页 查询首页list
    selectLsit(curPage, pageSize) {
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
        keyword: this.searchKey || "",
        isAdmin: this.isAdmin / 1,
        operatorId: this.userInfo.userId,
      };
      this.isTableLoading = true;
      this.$axios
        .post("/teacherAward/getTeacherStudentAwardsList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableData = res.data.records;
          } else {
            this.$message({
              message: "数据获取失败",
              type: "error",
            });
          }
          this.isTableLoading = false;
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    //导出
    importTeacher() {
      exportExecl(
        "/exp/expTeacherStudentAwards",
        "指导学生获奖-" + this.userInfo.userName,
        this.userInfo.schoolCode,
        this.pageObj.current,
        this.pageObj.size,
        this.searchYear,
        this.searchTerm
      );
    },
    // 删除弹框 关闭
    async closePopupDel(status) {
      try {
        !status && (this.delVisible = false);
        if (status) {
          let del = {
            clientPackage: "com.xueduoduo.teacher.archives.pc",
            id: this.selectRow.id,
            operatorId: this.userInfo.userId,
          };
          let { resultCode } = await this.$axios.post(
            "/teacherAward/deleteTeacherStudentAwards",
            del
          );
          if (resultCode === 200) {
            this.selectLsit(this.pageObj.current, this.pageObj.size),
              this.$message.success("删除成功");
          } else {
            this.$message.error(msg);
          }
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    //编辑
    showEdit(index, row) {
      this.selectRow = row;
      //重置效验样式
      this.$refs.form && this.$refs.form.resetFields();
      //查询教师的选择
      this.teacherKeyChange(row.teacherName);
      this.form = {
        id: row.id,
        awardingUnit: row.awardingUnit,
        schoolYear: row.schoolYear + "",
        schoolTerm: row.schoolTerm + "",
        awardType: row.awardType,
        awardName: row.awardName,
        studentName: row.studentName,
        awardType1: row.awardType1,
        remark: row.remark,
        // ruleList: [row.awardType1],
        score: row.score,
        awardDate: row.awardDate,
        teacherId: row.teacherId,
        teacherName: row.teacherName,
        awardAttach: row.awardAttach, //附件
        awardAttaches: row.awardAttaches, //附件
      };

      //判断 积分规则是否有删除，如果对应的积分已经删除，则 需要重新选择 积分分类
      // this.isInclude(this.ruleOptionsList, this.form.ruleList) ? "" : (this.form.ruleList = []);
      //积分可能发生改变重新获取积分
      this.getScore(row.awardType1);

      this.addVisible = true;
    },
    // 新增
    showAddPop() {
      //清空form表单
      this.form = {
        id: "",
        awardingUnit: "",
        schoolYear: "",
        schoolTerm: "",
        awardType: "",
        awardType1: "",
        awardName: "",
        studentName: "",
        ruleList: "",
        score: "",
        awardDate: "",
        teacherId: "",
        teacherName: "",
        awardAttach: "", //附件
        awardAttaches: [],
      };
      this.$refs.form && this.$refs.form.resetFields();
      this.addVisible = true;
    },
    //新增 或者 更新
    submitStudent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            //更新
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCode = this.userInfo.schoolCode;
            // [
            //   this.form.awardType1,
            //   this.form.awardType2,
            //   this.form.awardType3,
            // ] = this.form.ruleList;
            this.$axios
              .post("/teacherAward/updateTeacherStudentAwards", this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "更新成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  console.log("update else", res);
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          } else {
            //保存
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCode = this.userInfo.schoolCode;
            // [
            //   this.form.awardType1,
            //   this.form.awardType2,
            //   this.form.awardType3,
            // ] = this.form.ruleList;
            this.$axios
              .post("/teacherAward/saveTeacherStudentAwards", this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  console.log("this.form", this.form);
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "保存成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          }
        }
      });
    },
    uploadFileUrl(fileUrl, fileList) {
      this.form.awardAttaches = fileList;
      this.form.awardAttach = fileUrl;
    },
    getScore(val) {
      let find = this.ruleOptions.find((f) => f.integralCode == val);
      if (find) {
        this.form.score = find.integralNum;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../styles/common.less";
</style>
